module.exports = __webpack_public_path__ + "static/images/toolbars/googleStreetViewCloseBtn.png";